import axios from 'axios';
import API_URL from '../api/baseURL'; 

// Fetch vehicles for the logged-in user (WORKSHOP or OWNER)
export const fetchVehicles = async (token) => {
  const res = await axios.get(`${API_URL}/vehicles/mine`, {
    headers: {
      Authorization: `Bearer ${token || localStorage.getItem('authToken')}`,
    },
  });
  return res.data.filter(v => v.plateNumber && (v.brand || v.make) && v.model);
};

// Fetch vehicles assigned to this workshop
export const fetchAssignedVehicles = async (token) => {
  const res = await axios.get(`${API_URL}/vehicles/assigned`, {
    headers: {
      Authorization: `Bearer ${token || localStorage.getItem('authToken')}`,
    },
  });
  return res.data.filter(v => v.plateNumber && (v.brand || v.make) && v.model);
};

// Fetch a specific vehicle by ID
export const fetchVehicleById = async (id, token) => {
  const res = await axios.get(`${API_URL}/vehicles/${id}`, {
    headers: {
      Authorization: `Bearer ${token || localStorage.getItem('authToken')}`,
    },
  });
  return res.data;
};

// Fetch maintenance logs for a specific vehicle
export const fetchMaintenanceByVehicle = async (id, token) => {
  const res = await axios.get(`${API_URL}/maintenance/vehicle/${id}`, {
    headers: {
      Authorization: `Bearer ${token || localStorage.getItem('authToken')}`,
    },
  });
  return res.data;
};

// Create a new vehicle (just pass the payload directly)
export const createVehicle = async (payload, token) => {
  const res = await axios.post(`${API_URL}/vehicles`, payload, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
};

// Fetch only vehicles for the logged-in user (filtered, for dashboards)
export const fetchMyVehicles = async (token) => {
  const res = await axios.get(`${API_URL}/vehicles/mine`, {
    headers: {
      Authorization: `Bearer ${token || localStorage.getItem('authToken')}`,
    },
  });
  return res.data.filter(v => v.plateNumber && (v.brand || v.make) && v.model);
};

export const fetchInvoiceById = async (invoiceId, token) => {
  const res = await axios.get(`${API_URL}/workshop-invoices/${invoiceId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
};

